import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import sesameLogo from '@/assets/sesame.svg?inline';
import { authActions } from '@/stores/authStore';
import MaintenanceBanner from '@/components/core/MaintenanceBanner';
import { isMITX } from '@/utils/stackUtils';

const ForgotPasswordRoute = () => {
  const { register, handleSubmit } = useForm();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async data => {
    setError('');
    setSuccess(false);
    setIsLoading(true);

    try {
      const result = await authActions.forgotPassword(data);

      if (result?.error) {
        setError(result?.error);
        return;
      }

      setSuccess(true);
    } catch (err) {
      setError(err?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-base-200 flex flex-col items-center">
      <img src={sesameLogo} alt="Logo" className="w-48 h-32 mt-4 mb-8" />
      <div className="card w-full max-w-xl shadow">
        <div className="grid grid-cols-1 bg-base-100 rounded">
          <div className="py-20 px-10">
            <h2 className="text-2xl font-semibold mb-2 text-center">Forgot Password</h2>
            {success ? (
              <div className="text-center">
                <p className="mb-4">A new password has been sent to your email.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-4">
                  <div className="form-control w-full mt-4">
                    <label className="label">
                      <span className="label-text text-base-content">Email</span>
                    </label>
                    <input
                      {...register('email', { required: true })}
                      className="input input-bordered w-full"
                      type="email"
                    />
                  </div>
                </div>
                {error && <p className="text-center text-error">{error}</p>}
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`btn mt-2 w-full ${isMITX() ? 'bg-[#7A0019] hover:bg-[#B10E1E] text-white' : 'btn-accent'} ${isLoading ? 'btn-disabled' : ''}`}
                >
                  {isLoading && <span className="loading loading-spinner"></span>}
                  {isLoading ? 'Please wait...' : 'Send'}
                </button>
              </form>
            )}
            <div className="text-center mt-4">
              <Link to="/login" className="link link-primary">
                Go back to login
              </Link>
            </div>
          </div>
          <MaintenanceBanner />
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordRoute;
